import React, {Fragment, FunctionComponent, KeyboardEvent, useState} from "react"
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from '@App/state'
import {useTranslation} from "react-i18next";
import {bindActionCreators} from "@reduxjs/toolkit";
import {Button} from "@App/Components/Funnel/Button";
import {FunnelHeader} from "@App/Components/Funnel/FunnelHeader";
import {Loader} from "@App/Components/Loader";
import {parseISO} from "date-fns";
import {CaretDownIcon} from "@App/Components/common/Icons";

export type RegistrationDateProps = {
    headline: string
    step: number
    maxSteps: number
    onSubmit?: (registrationDate: Date) => void
}

export const RegistrationDate: FunctionComponent<RegistrationDateProps> = ({
                                                                               headline,
                                                                               step,
                                                                               maxSteps,
                                                                               onSubmit
                                                                           }: RegistrationDateProps) => {

    const {t} = useTranslation()
    const initialRegistrationDate = useSelector((state: State) => state.orders.initialRegistrationDate)
    const motorization = useSelector((state: State) => state.orders.motorization)

    const dispatch = useDispatch();
    const {setRegistrationDate} = bindActionCreators(actionCreators, dispatch)

    const [registrationMonth, setRegistrationMonth] = useState(initialRegistrationDate ? initialRegistrationDate.getMonth().toString() : '')
    const [registrationYear, setRegistrationYear] = useState(initialRegistrationDate ? initialRegistrationDate.getFullYear().toString() : '')

    const handleRegistrationMonth = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setRegistrationMonth(e.target.value)
    }

    const handleRegistrationYear = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        setRegistrationYear(e.target.value)
    }

    const submit = (): void => {
        setRegistrationDate(new Date(parseInt(registrationYear), parseInt(registrationMonth)))
        onSubmit && onSubmit(new Date(parseInt(registrationYear), parseInt(registrationMonth)))
    }

    const handleKeyDown = (e: KeyboardEvent<HTMLSelectElement>): void => {
        if (e.key === 'Enter' && registrationMonth && registrationYear) {
            submit()
        }
    }

    if (!motorization) {
        return <Loader/>
    }

    return (
        <Fragment>
            <div className="
                    container bg-white
                    pt-10 pb-12
                ">
                <FunnelHeader heading={headline}
                              step={step}
                              maxSteps={maxSteps}
                              subheading={t('registrationDate.headline')}
                              description={t('registrationDate.description')}
                />
                <div className="md:w-1/3 flex gap-3">
                    <div className={'relative w-full flex items-center'}>
                        <select
                            className={'w-full appearance-none bg-white border border-neutral-500 rounded-md cursor-pointer p-3'}
                            value={registrationMonth ?? ''} onChange={handleRegistrationMonth}>
                            <option value="" disabled>Monat</option>
                            {Array.from(Array(12).keys()).map(i => <option key={i} value={i + 1}>{i + 1}</option>)}
                        </select>
                        <CaretDownIcon className={'absolute right-3'}/>
                    </div>
                    <div className={'relative w-full flex items-center'}>
                        <select
                            className={'w-full appearance-none bg-white border border-neutral-500 rounded-md cursor-pointer p-3'}
                            value={registrationYear ?? ''} onChange={handleRegistrationYear} onKeyDown={handleKeyDown}>
                            <option value="" disabled>Jahr</option>
                            {Array.from(Array(new Date().getFullYear() - parseISO(motorization.built_from.toString()).getFullYear()).keys()).map(i =>
                                <option key={i}
                                        value={new Date().getFullYear() - i}>{new Date().getFullYear() - i}</option>)}
                        </select>
                        <CaretDownIcon className={'absolute right-3'}/>
                    </div>
                </div>
                <Button title={t('registrationDate.submit')}
                        disabled={registrationMonth === '' || registrationYear === ''}
                        onClick={submit}/>
            </div>
        </Fragment>
    );
}
